import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { Http, HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { ROUTES } from './app.routes';

//import { DxFormModule, DxButtonModule, DxPopupModule, DxDataGridModule } from 'devextreme-angular';
import { DevExtremeModule } from 'devextreme-angular';
import { locale, loadMessages } from 'devextreme/localization';
import 'devextreme-intl';
import { messagesLocale } from './app.config';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { FooterComponent } from './footer/footer.component';

import { ContratoComponent } from './contrato/contrato.component';
import { ContratosComponent } from './contratos/contratos.component';
import { OrdemServicoComponent } from './ordem-servico/ordem-servico.component';
import { EquipeComponent } from './equipe/equipe.component';
import { AssinantesComponent } from './assinantes/assinantes.component';

import { ContratosService } from './contratos/contratos.services';
import { EquipeService } from './equipe/equipe.service';
import { AssinantesService } from './assinantes/assinantes.service';
import { AssinanteComponent } from './assinante/assinante.component';
import { PessoaComponent } from './pessoa/pessoa.component';
import { PaisComponent } from './pais/pais.component';
import { EstadoComponent } from './estado/estado.component';
import { PaisService } from './pais/pais.service';
import { EnderecoLocalTipoComponent } from './endereco-local-tipo/endereco-local-tipo.component';
import { LocalidadeComponent } from './localidade/localidade.component';
import { EstadoService } from './estado/estado.service';
import { LogradouroComponent } from './logradouro/logradouro.component';
import { LocalidadeService } from './localidade/localidade.service';
import { LogradouroCepComponent } from './logradouro-cep/logradouro-cep.component';
import { LogradouroService } from './logradouro/logradouro.service';
import { LogradouroCepService } from './logradouro-cep/logradouro-cep.service';
import { EnderecoLocalTipoService } from './endereco-local-tipo/endereco-local-tipo.service';
import { BairroComponent } from './bairro/bairro.component';
import { BairroService } from './bairro/bairro.service';
import { EmpresaComponent } from './empresa/empresa.component';
import { FilialComponent } from './filial/filial.component';
import { FornecedorComponent } from './fornecedor/fornecedor.component';
import { TecnicoComponent } from './tecnico/tecnico.component';
import { UsuarioSistemaComponent } from './usuario-sistema/usuario-sistema.component';
import { UsuariosSistemaComponent } from './usuarios-sistema/usuarios-sistema.component';
import { EmpresaService } from './empresa/empresa.service';
import { UsuarioSistemaService } from './usuario-sistema/usuario-sistema.service';
import { ProdutoComponent } from './produto/produto.component';
import { FuncaoEquipamentoComponent } from './funcao-equipamento/funcao-equipamento.component';
import { PromocaoComponent } from './promocao/promocao.component';
import { ProdutoSegmentoComponent } from './produto-segmento/produto-segmento.component';
import { FuncaoEquipamento } from './funcao-equipamento/funcao-equipamento.model';
import { FuncaoEquipamentoService } from './funcao-equipamento/funcao-equipamento.service';
import { ProdutoService } from './produto/produto.service';
import { ProdutoPromocaoComponent } from './produto-promocao/produto-promocao.component';
import { ProdutoPacoteComponent } from './produto-pacote/produto-pacote.component';
import { ProdutoSegmentoService } from './produto-segmento/produto-segmento.service';
import { ProdutoPacoteService } from './produto-pacote/produto-pacote.service';
import { ItemComponent } from './item/item.component';
import { ItemService } from './item/item.service';
import { ItemSerieComponent } from './item-serie/item-serie.component';
import { ProtocoloAtendimentoTipoComponent } from './protocolo-atendimento-tipo/protocolo-atendimento-tipo.component';
import { PromocaoService } from './promocao/promocao.service';
import { ProtocoloTipoComponent } from './protocolo-tipo/protocolo-tipo.component';
import { ServicoComponent } from './servico/servico.component';
import { ProtocoloAssuntoComponent } from './protocolo-assunto/protocolo-assunto.component';
import { ProtocoloTipoService } from './protocolo-tipo/protocolo-tipo.service';
import { ProtocoloMotivoComponent } from './protocolo-motivo/protocolo-motivo.component';
import { ProtocoloAssuntoService } from './protocolo-assunto/protocolo-assunto.service';
import { OrdensServicoComponent } from './ordens-servico/ordens-servico.component';
import { FilialService } from './filial/filial.service';
import { ItemSerieService } from './item-serie/item-serie.service';
import { ServicoService } from './servico/servico.service';
import { TecnicoService } from './tecnico/tecnico.service';
import { OrdemServicoService } from './ordem-servico/ordem-servico.service';
import { ProtocoloComponent } from './protocolo/protocolo.component';
import { ProtocolosComponent } from './protocolos/protocolos.component';
import { ProtocoloService } from './protocolo/protocolo.service';
import { ProtocoloMotivoService } from './protocolo-motivo/protocolo-motivo.service';
import { ProtocoloAtendimentoTipoService } from './protocolo-atendimento-tipo/protocolo-atendimento-tipo.service';
import { ClienteTipoComponent } from './cliente-tipo/cliente-tipo.component';
import { AutorizacaoTipoComponent } from './autorizacao-tipo/autorizacao-tipo.component';
import { LinhaTelefonicaComponent } from './linha-telefonica/linha-telefonica.component';
import { OperadoraComponent } from './operadora/operadora.component';
import { MotivoInativacaoComponent } from './motivo-inativacao/motivo-inativacao.component';
import { MotivoCancelamentoComponent } from './motivo-cancelamento/motivo-cancelamento.component';
import { BancoAgenciaComponent } from './banco-agencia/banco-agencia.component';
import { BancoComponent } from './banco/banco.component';
import { UsuarioGrupoComponent } from './usuario-grupo/usuario-grupo.component';
import { ReligiaoComponent } from './religiao/religiao.component';
import { ProfissaoComponent } from './profissao/profissao.component';
import { BancoService } from './banco/banco.service';
import { OperadoraService } from './operadora/operadora.service';
import { UsuarioGrupoService } from './usuario-grupo/usuario-grupo.service';
import { CobrancaTipoComponent } from './cobranca-tipo/cobranca-tipo.component';
import { CobrancaTipoService } from './cobranca-tipo/cobranca-tipo.service';
import { AutorizacaoTipoService } from './autorizacao-tipo/autorizacao-tipo.service';
import { FabricanteComponent } from './fabricante/fabricante.component';
import { FabricanteService } from './fabricante/fabricante.service';
import { CanalComponent } from './canal/canal.component';
import { FornecedorService } from './fornecedor/fornecedor.service';
import { SideBarService } from './sidebar/sidebar.service';
import { MotivoCancelamentoService } from './motivo-cancelamento/motivo-cancelamento.service';
import { BancoAgenciaService } from './banco-agencia/banco-agencia.service';
import { ClienteTipoService } from './cliente-tipo/cliente-tipo.service';
import { AutorizadorGuard } from './autorizador.guard';
import { LoginComponent } from './login/login.component';
import { LoginService } from './login/login.service';
import { PermissaoNegadaComponent } from './permissao-negada/permissao-negada.component';
import { MapaTecnicoComponent } from './tecnico/mapa-tecnico/mapa-tecnico.component';
import { EnderecoWsCepComponent } from './endereco-ws-cep/endereco-ws-cep.component';
import { EnderecoWsCepService } from './endereco-ws-cep/endereco-ws-cep.service';

// carrega as configurações de traducao das mensagens e botoes
loadMessages(messagesLocale);
locale('pt');

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    ContratoComponent,
    OrdemServicoComponent,
    HomeComponent,
    ContratosComponent,
    EquipeComponent,
    SidebarComponent,
    AssinantesComponent,
    AssinanteComponent,
    PessoaComponent,
    PaisComponent,
    EstadoComponent,
    EnderecoLocalTipoComponent,
    LocalidadeComponent,
    LogradouroComponent,
    LogradouroCepComponent,
    BairroComponent,
    EmpresaComponent,
    FilialComponent,
    FornecedorComponent,
    TecnicoComponent,
    UsuarioSistemaComponent,
    UsuariosSistemaComponent,
    ProdutoComponent,
    FuncaoEquipamentoComponent,
    PromocaoComponent,
    ProdutoSegmentoComponent,
    ProdutoPromocaoComponent,
    ProdutoPacoteComponent,
    ItemComponent,
    ItemSerieComponent,
    ProtocoloAtendimentoTipoComponent,
    ProtocoloTipoComponent,
    ServicoComponent,
    ProtocoloAssuntoComponent,
    ProtocoloMotivoComponent,
    OrdensServicoComponent,
    ProtocoloComponent,
    ProtocolosComponent,
    ClienteTipoComponent,
    AutorizacaoTipoComponent,
    LinhaTelefonicaComponent,
    OperadoraComponent,
    MotivoInativacaoComponent,
    MotivoCancelamentoComponent,
    BancoAgenciaComponent,
    BancoComponent,
    UsuarioGrupoComponent,
    ReligiaoComponent,
    ProfissaoComponent,
    CobrancaTipoComponent,
    FabricanteComponent,
    CanalComponent,
    LoginComponent,
    PermissaoNegadaComponent,
    MapaTecnicoComponent,
    EnderecoWsCepComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    //DxFormModule,
    //DxButtonModule,
    //DxPopupModule,
    //DxDataGridModule,
    DevExtremeModule,
    RouterModule.forRoot(ROUTES),
    ReactiveFormsModule
  ],
  providers: [
    ContratosService,
    EquipeService,
    AssinantesService,
    PaisService,
    EstadoService,
    LocalidadeService,
    LogradouroService,
    LogradouroCepService,
    EnderecoLocalTipoService,
    BairroService,
    EmpresaService,
    UsuarioSistemaService,
    FuncaoEquipamentoService,
    ProdutoService,
    ProdutoSegmentoService,
    ProdutoPacoteService,
    ItemService,
    PromocaoService,
    ProtocoloTipoService,
    ProtocoloAssuntoService,
    ItemSerieService,
    FilialService,
    ServicoService,
    TecnicoService,
    OrdemServicoService,
    ProtocoloService,
    ProtocoloMotivoService,
    ProtocoloAtendimentoTipoService,
    BancoService,
    OperadoraService,
    UsuarioGrupoService,
    CobrancaTipoService,
    AutorizacaoTipoService,
    FabricanteService,
    FornecedorService,
    SideBarService,
    MotivoCancelamentoService,
    BancoAgenciaService,
    ClienteTipoService,
    AutorizadorGuard,
    LoginService,
    EnderecoWsCepService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts